// Shared axios instance + token helpers. Extracted from api.js during the
// refactor sprint so per-domain modules can import a common client without
// re-creating interceptors or duplicating localStorage keys.
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API = axios.create({ baseURL: `${BACKEND_URL}/api` });
export const API_BASE = `${BACKEND_URL}/api`;
export const BACKEND = BACKEND_URL;

export const TOKEN_KEY = 'immipro_token';
export const USER_KEY = 'immipro_user';
export const PORTAL_TOKEN_KEY = 'immipro_portal_token';
export const PORTAL_MATTER_KEY = 'immipro_portal_matter';

API.interceptors.request.use((config) => {
  // For portal routes, prefer portal token; else staff token.
  const url = config.url || '';
  const isPortal = (url.startsWith('/portal/') && !url.startsWith('/portal/magic'))
    || url.startsWith('/documents/portal') || url.startsWith('/payments/checkout');
  const token = isPortal ? localStorage.getItem(PORTAL_TOKEN_KEY) : localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Global 401 handler — an expired/invalid session shouldn't leave the user
// stuck on a broken screen. Clear tokens and bounce to the appropriate login.
API.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const url = err.config?.url || '';
      const path = window.location.pathname || '';
      const isPortalRoute = path.startsWith('/portal') || url.startsWith('/portal/');
      const isLoginCall = url.includes('/auth/login') || url.includes('/portal/magic');
      if (!isLoginCall) {
        if (isPortalRoute) {
          localStorage.removeItem(PORTAL_TOKEN_KEY);
          if (!path.startsWith('/portal/verify')) window.location.assign('/portal');
        } else {
          localStorage.removeItem(TOKEN_KEY);
          localStorage.removeItem(USER_KEY);
          if (path !== '/login') window.location.assign('/login');
        }
      }
    }
    return Promise.reject(err);
  },
);
